import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { BasicSearchSection } from "./section/basic-search-actions";
import { SearchResultTable } from "./table";
import { SalesHeaderAndTab } from "../../../_shared";
import { useInitialized } from "../../model/use-case";

type Props = {
	hotelID: string;
};

export const ManagementSalesSearch = ({ hotelID }: Props) => {
	/**
	 * 初期化
	 */
	const {
		//
		searchType,
		onSetSearchType,

		viewData,

		//
		onSearchSalesMastList,
	} = useInitialized({ hotelID });

	return (
		<FeatureIslandContainer>
			<SalesHeaderAndTab hotelID={hotelID} />

			<FeatureIslandMainWithBackGround>
				<div>
					{/* 通常検索セクション */}
					<BasicSearchSection
						onSearchSalesMastList={onSearchSalesMastList}
						searchType={searchType}
						onSetSearchType={onSetSearchType}
					/>

					{/* 検索結果テーブル */}
					<div className="mt-10">
						<SearchResultTable viewData={viewData} />
					</div>
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

ManagementSalesSearch.displayName = "ManagementSalesSearch";
